import { useState, useEffect, useRef, useCallback } from 'react';
import { api } from '../api';
import { formatDateTime, timeAgo, DEFAULT_TZ, useIsMobile } from '../utils';

const levelColor = { ok: 'var(--green)', warn: 'var(--yellow)', error: 'var(--red)', info: 'var(--accent)' };
const levelLabel = { ok: '[OK]  ', warn: '[WARN]', error: '[ERR] ', info: '[INFO]' };

export default function Logs() {
  const isMobile              = useIsMobile();
  const [logs, setLogs]       = useState([]);
  const [loading, setLoading] = useState(true);
  const bottomRef             = useRef(null);

  const load = useCallback(async () => {
    try {
      const data = await api.getLogs();
      setLogs([...data].reverse());
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, [load]);
  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [logs]);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 24 }}>
        <div>
          <div style={{ fontFamily: 'var(--mono)', fontSize: 20 }}>Logs</div>
          <div style={{ fontSize: 13, color: 'var(--muted)', marginTop: 4 }}>Registro de actividad del sistema</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--green)', boxShadow: '0 0 8px var(--green)', animation: 'pulse 2s infinite' }} />
          <span style={{ fontSize: 11, fontFamily: 'var(--mono)', color: 'var(--green)' }}>AUTO-REFRESH 10s</span>
          <button onClick={load} style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--text)', padding: '7px 14px', fontSize: 12, fontFamily: 'var(--mono)', cursor: 'pointer' }}>⟳ ACTUALIZAR</button>
        </div>
      </div>

      <div style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontFamily: 'var(--mono)', fontSize: 12, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)' }}>Log del sistema</span>
          <span style={{ fontFamily: 'var(--mono)', fontSize: 10, color: 'var(--muted)', letterSpacing: 1 }}>HORA: ARG (UTC-3)</span>
        </div>
        <div style={{ background: 'var(--bg)', padding: 16, fontFamily: 'var(--mono)', fontSize: 12, lineHeight: 2, maxHeight: 500, overflowY: 'auto' }}>
          {loading && <div style={{ color: 'var(--muted)' }}>Cargando logs...</div>}
          {!loading && logs.length === 0 && <div style={{ color: 'var(--muted)' }}>Sin logs todavía.</div>}
          {logs.map((l, i) => (
            <div key={i}>
              <span style={{ color: 'var(--muted)' }} title={timeAgo(l.created_at)}>{formatDateTime(l.created_at, DEFAULT_TZ)}</span>
              {' '}
              <span style={{ color: levelColor[l.level] || 'var(--muted)' }}>{levelLabel[l.level] || '[INFO]'}</span>
              {' '}
              {l.message}
            </div>
          ))}
          <div ref={bottomRef} />
        </div>
      </div>
      <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.4} }`}</style>
    </div>
  );
}
